export default "__VITE_ASSET__B8P9Vfks__"